<template>
  <section v-bind:class="css" v-bind:style="additionalBoxStyle">
    <p class="text-line" v-bind:style="additionalLineStyle"></p>
  </section>
</template>

<script>
  export default {
    name: 'loading-progress',
    data() {
      return {
        styleLoading: ''
      }
    },
    props:['css', 'additionalBoxStyle', 'additionalLineStyle'],
    methods: {
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/vue/views/components/progressLoading.vue